import { c as _c } from "react/compiler-runtime";
import { ForwardedRef, forwardRef } from 'react';
import css from './style.module.scss';
const Loader = (_, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <video loop={true} muted={true} autoPlay={true} playsInline={true} controls={false} preload="auto"><source src="/assets/video/mov/hero-chub-loader.mov" type={"video/quicktime; codecs=\"hvc1\""} /><source src="/assets/video/webm/hero-chub-loader.webm" type="video/webm" /></video>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== ref) {
    t1 = <div ref={ref} className={css.wrapper}>{t0}</div>;
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default forwardRef<HTMLDivElement, any>(Loader);